"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));

var _AppNumberField = _interopRequireDefault(require("../../../../components/elements/form/AppNumberField"));

var _UserModel = _interopRequireDefault(require("../models/UserModel"));

var _DateHelper = _interopRequireDefault(require("../../../../util/DateHelper"));

var _index = require("../../../../index");

var _CountryModel = _interopRequireDefault(require("../../../../logic/model/CountryModel"));

var _AppSelect = _interopRequireDefault(require("../../../../components/crud/AppSelect"));

var _eonasdanBootstrapDatetimepicker = _interopRequireDefault(require("eonasdan-bootstrap-datetimepicker"));

var _bootstrapDatetimepicker = _interopRequireDefault(require("../../../../styles/bootstrap/bootstrap-datetimepicker.css"));

var _jquery = _interopRequireDefault(require("jquery"));

var _moment = _interopRequireDefault(require("moment"));

var _reactDatepicker = _interopRequireDefault(require("react-datepicker"));

require("react-datepicker/dist/react-datepicker.css");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var UserForm = /*#__PURE__*/function (_Component) {
  _inherits(UserForm, _Component);

  function UserForm(props) {
    var _this;

    _classCallCheck(this, UserForm);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(UserForm).call(this, props)); // Initial state

    _this.formHandler = new _index.FormHandler(_assertThisInitialized(_this), new _UserModel["default"]({
      firstName: '',
      lastName: '',
      email: '',
      mobileCountryCode: '+44',
      mobileShort: '',
      birthDate: new Date(),
      addressOne: '',
      addressTwo: '',
      city: '',
      postCode: '',
      customerReference: '',
      countryId: 225 // firstName: 'Boban',
      // lastName: 'Cirkovic',
      // email: 'cirkovic.bob+101@gmail.com',
      // mobileCountryCode: '+381',
      // mobileShort: '616353940',
      // birthDate: '1989-11-01',
      // addressOne: 'Test address one',
      // addressTwo: 'Test address two',
      // city: 'London',
      // postCode: '11000',
      // customerReference: '23424234-23423-2342-234234',
      // countryId: 225,

    }));
    return _this;
  }

  _createClass(UserForm, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var id = this.props.id;

      if (id) {
        new _UserModel["default"]().get(id).then(function (result) {
          _this2.setState({
            // record: { ...result, countryId: 225 }
            record: result
          });
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var formHandler = this.formHandler;
      return _react["default"].createElement("div", null, _react["default"].createElement("h1", null, this.props.title), _react["default"].createElement("div", {
        className: "element-with-blur",
        style: {
          paddingTop: '2px',
          marginRight: 20
        }
      }, _react["default"].createElement("div", {
        className: "dark-blur"
      }), _react["default"].createElement("div", {
        className: "box-header"
      }, _react["default"].createElement("h2", null, this.props.title)), _react["default"].createElement("div", {
        className: "add-new-group",
        style: {
          position: 'relative'
        }
      }, _react["default"].createElement("div", {
        className: "container"
      }, _react["default"].createElement(_index.FormSubmitWrapper, {
        formHandler: formHandler,
        to: "/users/all-users"
      }, _react["default"].createElement("div", {
        className: "row"
      }, _react["default"].createElement("div", {
        className: "col-md-6"
      }, _react["default"].createElement(_index.InputField, {
        materialProps: {
          fullWidth: true
        },
        InputLabelProps: {
          shrink: true
        },
        customInput: _TextField["default"],
        label: "First Name",
        type: "text",
        name: "firstName",
        value: this.state.record.firstName,
        handler: formHandler
      }), _react["default"].createElement(_index.InputField, {
        materialProps: {
          fullWidth: true
        },
        InputLabelProps: {
          shrink: true
        },
        label: "Last Name",
        type: "text",
        name: "lastName",
        value: this.state.record.lastName,
        handler: formHandler
      }), _react["default"].createElement(_index.InputField, {
        materialProps: {
          fullWidth: true
        },
        InputLabelProps: {
          shrink: true
        },
        label: "Email",
        type: "email",
        name: "email",
        value: this.state.record.email,
        handler: formHandler
      }), _react["default"].createElement("div", {
        className: "row"
      }, _react["default"].createElement("div", {
        className: "col-sm-7 input-wrap"
      }, _react["default"].createElement(_AppSelect["default"], {
        textFieldProps: {
          label: 'Country Code',
          InputLabelProps: {
            shrink: true
          }
        },
        model: _CountryModel["default"],
        getOptionValue: function getOptionValue(country) {
          return '+' + country.phonecode;
        },
        getOptionLabel: function getOptionLabel(country) {
          return country.name + ' (+' + country.phonecode + ')';
        },
        name: "mobileCountryCode",
        value: this.state.record.mobileCountryCode,
        handler: formHandler,
        placeholder: "Search a Country"
      })), _react["default"].createElement("div", {
        className: "col-sm-5 input-wrap-mobile"
      }, _react["default"].createElement(_AppNumberField["default"], {
        format: "###########",
        label: "Mobile",
        type: "tel",
        name: "mobileShort",
        value: this.state.record.mobileShort,
        handler: formHandler
      }))), _react["default"].createElement(_reactDatepicker["default"], {
        selected: (0, _moment["default"])(this.state.record.birthDate).toDate(),
        onChange: function onChange(date) {
          return _this3.formHandler.handleInputChange('birthDate', (0, _moment["default"])(date).format('YYYY-MM-DD'));
        },
        style: {
          width: '100%'
        },
        dateFormat: "dd/MM/yyyy",
        showMonthDropdown: true,
        showYearDropdown: true,
        dropdownMode: "select",
        customInput: _react["default"].createElement(_index.InputField, {
          materialProps: {
            fullWidth: true
          },
          InputLabelProps: {
            shrink: true
          },
          inputProps: {},
          label: "Birth day",
          type: "text",
          value: "",
          name: "birthDate"
        })
      }), _react["default"].createElement(_index.InputField, {
        materialProps: {
          fullWidth: true
        },
        InputLabelProps: {
          shrink: true
        },
        label: "Customer reference",
        type: "text",
        name: "customerReference",
        value: this.state.record.customerReference,
        handler: formHandler
      })), _react["default"].createElement("div", {
        className: "col-md-6"
      }, _react["default"].createElement(_index.InputField, {
        materialProps: {
          fullWidth: true
        },
        InputLabelProps: {
          shrink: true
        },
        label: "Address one",
        type: "text",
        name: "addressOne",
        value: this.state.record.addressOne,
        handler: formHandler
      }), _react["default"].createElement(_index.InputField, {
        materialProps: {
          fullWidth: true
        },
        InputLabelProps: {
          shrink: true
        },
        label: "Address two",
        type: "text",
        name: "addressTwo",
        value: this.state.record.addressTwo,
        handler: formHandler
      }), _react["default"].createElement(_index.InputField, {
        materialProps: {
          fullWidth: true
        },
        InputLabelProps: {
          shrink: true
        },
        label: "City",
        type: "text",
        name: "city",
        value: this.state.record.city,
        handler: formHandler
      }), _react["default"].createElement(_index.InputField, {
        materialProps: {
          fullWidth: true
        },
        InputLabelProps: {
          shrink: true
        },
        label: "Post Code",
        type: "text",
        name: "postCode",
        value: this.state.record.postCode,
        handler: formHandler
      }), _react["default"].createElement("div", {
        className: "input-wrap-country"
      }, _react["default"].createElement(_AppSelect["default"], {
        textFieldProps: {
          label: 'Country',
          InputLabelProps: {
            shrink: true
          }
        },
        model: _CountryModel["default"],
        name: "countryId",
        value: this.state.record.countryId,
        handler: formHandler,
        placeholder: "Search a Country"
      })))))))));
    }
  }]);

  return UserForm;
}(_react.Component);

exports["default"] = UserForm;
UserForm.defaultProps = {
  title: '',
  id: null
};